import { Platform } from "react-native";

export enum AppRoute {
  AUTH_CALLBACK = "auth-callback",
  HOME = "home",
  HOME_MAP = "map",
  HOME_LIST = "list",
  MYFILES = "files",
  FAVORITES = "favorites",
  FRIENDS = "friends",
  FRIEND_PROFILE = "friend",
}

export function webTitle(text: string) {
  return Platform.select({ web: `${text} - Bitdrop`, default: text });
}
